<div class="flex flex-col h-full w-full items-center justify-center p-4 pt-6">
  <div
    class="lg:w-[70%] sm:w-[96%] bg h-full justify-center overflow-x-auto overflow-y-auto lg:pt-16 md:pt-12"
  >
    <div class="w-full h-fit flex flex-row flex-wrap mx-auto">
      @for (item of videoGuideData(); track $index) {
        <div
          class="flex flex-row card lg:w-[48%] md:w-[48%] m-2 lg:h-fit rounded-xl sm:w-[80%] sm:mt-[2%] cursor-pointer items-center"
          (appClickableDirective)="openLink(item)"
        >
          <div
            class="w-[43%] h-[7rem] min-h-[7rem] relative flex justify-center items-center rounded-md"
          >
            <img
              src="{{ item.image }}"
              alt=" Thumbnail"
              class="w-full h-full object-cover rounded-md"
            />
            <img
              class="absolute"
              src="../../../../assets/images/customer_screens/play_icon.svg"
              alt="Play Video"
            />
          </div>
          <div class="flex flex-col ml-8 w-[70%] justify-center align-middle">
            <div>
              <p class="text-wrap text-white line-clamp-3">
                {{ item.title }}
              </p>
            </div>
            <div
              class="flex flex-row justify-between items-center align-middle text-white opacity-50"
            >
              <div class="flex justify-center">
                <img
                  src="../../../../assets/images/customer_screens/clock.svg"
                  alt="Video Thumbnail"
                />
                <span class="text-dark-content ml-4">{{ item.videoDate }}</span>
              </div>
              <div class="hidden">
                <span class="text-dark-content">Read more</span>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
